import * as React from "react";
const SvgDropdownicon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    {...props}
  >
    <path fill="#6366F1" d="M6.353 8.333 10.52 12.5l4.166-4.167H6.353Z" />
  </svg>
);
export default SvgDropdownicon;